import { configureStore, combineReducers } from "@reduxjs/toolkit";
import CartSlice from "./reducers/CartSlice";
import UserSlice from "./reducers/UserSlice";
import ApiUrlSlice from "./reducers/ApiUrlSlice";

// Define a function to persist the Redux state to localStorage
const saveStateToLocalStorage = (state) => {
    const { user, ...stateDefault } = state;
    try {

        if (user.userId) {
            const serializedStateUser = JSON.stringify(state);
            localStorage.setItem("reduxState", serializedStateUser);
        } else {
            const serializedStateDefault = JSON.stringify(stateDefault);
            localStorage.setItem("reduxState", serializedStateDefault);
        }
    } catch (e) {
        console.warn("Could not save state to localStorage:", e);
    }
};

// Define a function to load the persisted Redux state from localStorage
const loadStateFromLocalStorage = () => {
    try {
        const serializedState = localStorage.getItem("reduxState");
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (e) {
        console.warn("Could not load state from localStorage:", e);
        return undefined;
    }
};

// Combine your reducers into a single rootReducer
const rootReducer = combineReducers({
    cart: CartSlice,
    user: UserSlice,
    api: ApiUrlSlice,
});

// Load the persisted state from localStorage
const persistedState = loadStateFromLocalStorage();
// console.log(persistedState);
// Create your Redux store with persisted state and middleware to save the state to localStorage on every update
const store = configureStore({
    reducer: rootReducer,
    preloadedState: persistedState,
});
store.subscribe(() => {
    saveStateToLocalStorage(store.getState());
});

export default store;
